module.exports = __webpack_public_path__ + "static/media/hair-01.8e5848c9.jpg";